import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import GeneralButtonsChoiceSegmentButton from 'lumen/components/general/buttons/choice-segment-button';
import type { BeniSmartCompsetCategory } from 'lumen/models';

interface HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategorySignature {
  Args: {
    category: BeniSmartCompsetCategory;
    toggleCategory: (category: BeniSmartCompsetCategory) => void;
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategory =
  <template>
    <div class="smart-compset-builder__body__content__categories__category">
      <GeneralButtonsChoiceSegmentButton
        @className="smart-compset-builder__body__content__categories__category__checkbox"
        @isChecked={{@category.isChecked}}
        @label={{@category.formattedName}}
        @onClick={{fn @toggleCategory @category}}
        @type="checkbox"
      />
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategorySignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategory;
